/* Labulée – Custom Scroll-Reveal Effects (hinzugefügt von Claude)
   Blendet Sektionen beim Scrollen sanft ein. JS fügt den versteckten
   Zustand selbst hinzu -> ohne JS bleibt alles normal sichtbar. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function init() {
    var main = document.getElementById('main');
    if (!main) return;

    var sections = main.querySelectorAll(':scope > .shopify-section');
    if (!sections.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ce-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    sections.forEach(function (section, index) {
      // Erste Sektion (Hero / Above-the-fold) bleibt sofort sichtbar
      if (index === 0) return;
      section.classList.add('ce-reveal');
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
